import { getSheetIndex } from '../methods/get';

function setluckysheet_select_save(v) {
    const instance = this.instance;
    let Store = instance.getStore();
    Store.luckysheet_select_save = v;
}

function setluckysheet_scroll_status(v) {
    const instance = this.instance;
    let Store = instance.getStore();
    Store.luckysheet_scroll_status = v;
}

function setluckysheetfile(d) {
    const instance = this.instance;
    let Store = instance.getStore();
    Store.luckysheetfile = d;
}

function setconfig(v) {
    const instance = this.instance;
    let Store = instance.getStore();
    Store.config = v;

    if(Store.luckysheetfile != null){
        Store.luckysheetfile[instance.get.getSheetIndex(Store.currentSheetIndex)].config = v;
    }
}

function setvisibledatarow(v) {
    const instance = this.instance;
    let Store = instance.getStore();
    Store.visibledatarow = v;

    if(Store.luckysheetfile != null){
        Store.luckysheetfile[instance.get.getSheetIndex(Store.currentSheetIndex)].visibledatarow = v;
    }
}

function setvisibledatacolumn(v) {
    const instance = this.instance;
    let Store = instance.getStore();
    Store.visibledatacolumn = v;

    if(Store.luckysheetfile != null){
        Store.luckysheetfile[instance.get.getSheetIndex(Store.currentSheetIndex)].visibledatacolumn = v;  
    }
}

export {
    setluckysheet_select_save,
    setluckysheet_scroll_status,
    setluckysheetfile,
    setconfig,
    setvisibledatarow,
    setvisibledatacolumn,
}